import { Button, Modal, Upload, message } from 'antd';
import React, { useState } from 'react';
import CrudGenerator from 'admin/pages/shared/CrudGenerator/CrudGenerator';
import { columns, formSchema } from './LogsConfig';
import { MailOutlined, UploadOutlined, InboxOutlined } from '@ant-design/icons';
import LogsService from './LogsService';
import Cookies from 'lib/utils/Cookies';
import Constants from 'lib/Constants';
import './style.scss';
import LogsDetails from './LogsDetails';

const { Dragger } = Upload;

export default CrudGenerator({
    columns,
    formSchema,
    route: '/admin/logs',
    entityName: {
        entityNamePlural: "Logs",
        entityNameSingular: "Log"
    },
    getEntities: LogsService.getLogs,
    editEntity: LogsService.editLogs,
    deleteEntities: LogsService.deleteLogs,
    modalDetails: LogsDetails,
    defaultShowAddEditExpandButton: false,
})